// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".compiled.js?v=" + "1473dd3caf3bd35567d3" + "";
};